import * as React from 'react'

import { Box, CardInfo, ProgressBar, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import { SurveyFormStatsAuthorDocument } from 'generated/resources/graphql'
import { useAsyncData } from 'modules/core/hooks/useAsyncData'
import { useQuery } from 'modules/core/hooks/useQuery'
import { dateBackendDateTimeToUI } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'
import { getFullDisplayName } from 'modules/core/lib/userDisplayName'

import type Form from 'modules/surveys/store/models/Form'

import Item from './Item'

interface Props {
  form: Form
  header: React.ReactNode
}

function Stats({ form, header }: Props) {
  useAsyncData(() => form.fetch(), [])

  const accessId = form.attributes.access_id
  const { data } = useQuery(SurveyFormStatsAuthorDocument, {
    variables: { accessId },
    skip: !accessId,
  })

  const author = data?.apiCore.access
  const nextCycle = form.attributes.next_cycle

  return (
    <CardInfo header={header}>
      <Box flexDirection="row" justifyContent="spaceBetween">
        <Item label={i18n.t('surveys.form.configuration.stats.author')}>
          <Text.Normal>
            {author
              ? getFullDisplayName({
                  firstName: author.firstName,
                  lastName: author.lastName,
                })
              : '-'}
          </Text.Normal>
        </Item>
        <Item label={i18n.t('surveys.form.periodicity.label')}>
          <Text.Normal>{form.periodicity}</Text.Normal>
        </Item>
        <Item label={i18n.t('surveys.form.configuration.stats.start_on')}>
          <Text.Normal>
            {form.attributes.start_on ? dateBackendDateTimeToUI(form.attributes.start_on) : '-'}
          </Text.Normal>
        </Item>
        <Item label={i18n.t('surveys.form.configuration.stats.end_on')}>
          <Text.Normal>
            {form.attributes.end_on ? dateBackendDateTimeToUI(form.attributes.end_on) : '-'}
          </Text.Normal>
        </Item>
        <Item label={i18n.t('surveys.form.configuration.stats.next_cycle')}>
          <Text.Normal>{nextCycle ? dateBackendDateTimeToUI(nextCycle) : '-'}</Text.Normal>
        </Item>
        <Item grow label={i18n.t('surveys.form.configuration.stats.participation')}>
          {form.isDraft ? (
            '-'
          ) : (
            <ProgressBar
              showLabel
              amount={form.attributes.answered_question_groups_count}
              total={form.attributes.question_groups_count}
            />
          )}
        </Item>
      </Box>
    </CardInfo>
  )
}

export default observer(Stats)
